
/**
 * Converte para dinheiro no formato brasileiro
 * @param {string | number} valorNumerico 
 * @returns Valor em reais com R$ e virgula
 */
export function converterParaDinheiroString(valorNumerico) {
    if (valorNumerico == null || valorNumerico.length == 0) {
        return ""
    }
    let valorStr = valorNumerico.toFixed(2);
    // let valorStr = valorNumerico.toString();
    let novoValor = valorStr.replace(".", ",")
    return `R$ ${novoValor}`
}

/**
 * Converte uma string de dinheiro no formato brasileiro para um número
 * @param {string} valorString Valor em reais com R$ e virgula
 * @returns Valor numérico
 */
export function converterDinheirStringParaNumber(valorString) {
    let semSi = valorString.replace("R$ ", "")
    let comPonto = semSi.replace(",", ".")
    return parseFloat(comPonto)
}